<template>
  <div class="modal-preview-textbook-question">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container-outer">
          <ButtonClose
            class="modal-default-button"
            @click.native="$emit('close')"
          />
          <div
            ref="modalContainer"
            class="modal-container"
          >
            <div class="h-100 w-100 modal-contents-area">
              <div class="d-flex flex-column flex-fill modal-contents-area-inner">
                <div class="row">
                  <div
                    v-if="selectedHomeworkItemIndex !== 0"
                    class="col-2"
                  >
                    <div class="show-three-point">
                      No.{{ selectedHomeworkItemIndex }}
                    </div>
                  </div>
                  <div
                    v-if="bookName"
                    class="col-3"
                  >
                    <div class="show-three-point">
                      {{ bookName }}
                    </div>
                  </div>
                  <div class="col-7">
                    <div class="show-three-point">
                      {{ taskName }}
                    </div>
                  </div>
                </div>
                <div class="preview-wrapper pt-2">
                  <PreviewContainer
                    :image="image"
                    :setting-list="settingList"
                  />
                </div>
                <LoadingScreen v-if="isLoading" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * 宿題管理 - 教材の問題プレビューモーダル
 */
import ButtonClose from "@/components/atoms/buttons/ButtonClose.vue"
import PreviewContainer from "@/components/organisms/PreviewContainer.vue"
import questionRepository from "@/repositories/question"
import questionObjectGeneratorRepository from "@/repositories/questionObjectGenerator"
import LoadingScreen from "@/components/atoms/LoadingScreen.vue"
import accountRepository from "@/repositories/account"

export default {
  name: "ModalPreviewTextbookQuestion",
  components: {
    ButtonClose,
    PreviewContainer,
    LoadingScreen,
  },
  props: {
    taskName: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },
    item: {
      type: Object,
      require: true,
      default: function () {
        return {}
      },
    },
    curriculum: {
      type: String,
      require: true,
      default: function () {
        return ""
      },
    },
    loginUserInfo: {
      type: Object,
      default: function () {
        return {}
      },
    },
    streamGroup: {
      type: Number,
      default: function () {
        return 0
      },
    },
    studentItems: {
      type: Array,
      require: true,
      default: function () {
        return []
      },
    },
    bookItems: {
      type: Array,
      require: true,
      default: function () {
        return []
      },
    },
    selectedHomeworkItemIndex: {
      type: Number,
      default: function () {
        return 0
      },
    },
  },

  data: () => ({
    colorLayoutTheme: "#ff7f27",
    image: null,
    questionList: [],
    settingList: null,
    isLoading: false,
  }),
  computed: {
    /**
     * bookIdから書籍タイトルを取得
     * @returns 書籍タイトル
     */
    bookName() {
      const book = this.bookItems.find(
        (book) => book.bookId === this.item.bookId
      )
      return book ? book.bookTitle : ""
    },

    /**
     * bookIdから書籍の画像の拡張子を取得
     * @returns 画像拡張子
     */
    bookImgType() {
      const book = this.bookItems.find(
        (book) => book.bookId === this.item.bookId
      )
      if(!book || book.version == "" || book.imgExtension == ""){
        return "jpg"
      }

      console.log(book);

      const borderVersion = process.env.VUE_APP_IMGTYPE_BORDER
      const bookVersions = book.version.split('.').map(Number);
      const borderVersions = borderVersion.split('.').map(Number);

      //教材のメジャーバージョンがボーダーより新しい or 教材の方が2桁目のバージョンが新しい(メジャーバージョンは同じ)
      if(bookVersions[0] > borderVersions[0] || (bookVersions[0] == borderVersions[0] && bookVersions[1] >= borderVersions[1])){
        return book.imgExtension;
      }

      return "jpg"
    },
  },

  async mounted() {
    // リサイズ時にモーダルサイズの調整を行う（iPad対応）
    window.addEventListener('resize', () => {
      this.adjustModal();
    });
    this.adjustModal();

    this.isLoading = true
    this.settingList = null
    // プレビュー画像のパスを作成
    const imgType = this.bookImgType
    const img = `./textbook/${this.curriculum}/${this.item.bookId}/${this.item.chapterId}/page/learning_img/${this.item.quesParentId}.${imgType}`

    try {
      await this.getBookAndStudentAccount()
      await this.getTextbookConfig()
      await this.getSettingFilterTab()
      await this.getImg(img,imgType)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    /**
     * モーダルサイズ調整
     */
    adjustModal() {
      var e = this.$refs.modalContainer;
      if (e) {
        var v = window.innerHeight;
        e.style.height = `${ (v - 20) }px`;
      }
    },

    /**
     * 書籍と書籍を持つ生徒アカウントから
     * 教材パッケージの閲覧権限を取得
     */
    async getBookAndStudentAccount() {
      try {
        const bookAndAccount = await accountRepository.getBookAndStudentAccount(
          this.studentItems,
          this.bookItems,
          this.item.bookId
        )
        await this.getCredentials(bookAndAccount)
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * 教材パッケージの閲覧権限を取得
     * @returns 閲覧権限 Cookie
     */
    async getCredentials(bookAndAccount) {
      if (!bookAndAccount || !bookAndAccount.student || !bookAndAccount.book) {
        console.warn(`教材情報が存在しないため閲覧権限の取得は行いません`)
        return
      }
      try {
        return await accountRepository.getCookieSukenAccountWithBooks(
          this.streamGroup,
          bookAndAccount.student.accountId,
          bookAndAccount.book.productIds[0],
          this.item.bookId,
          this.loginUserInfo.accountId,
          this.loginUserInfo.sessionToken
        )
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    /**
     * 教材を取得
     */
    async getTextbookConfig() {
      try {
        const textbookConfigPromise =
          await questionRepository.getTextbookConfigJson(
            this.curriculum,
            this.item.bookId
          )
        this.$set(this, "questionList", textbookConfigPromise.data)
      } catch (error) {
        console.error(error)
      }
    },
    /**
     * ３タブを取得
     */
    async getSettingFilterTab() {
      try {
        const previewTab = []
        const tabList = questionObjectGeneratorRepository.getDisplayFilterTab(
          this.questionList,
          null
        )
        // 1,2タブの時nullを入れる
        for (let tab of tabList) {
          previewTab.push(tab.label ? tab : null)
        }
        this.settingList = previewTab
      } catch (error) {
        console.error(error)
        throw error
      }
    },
    /**
     * プレビュー画像を取得
     * @param {String} imgSrc プレビュー画像のパス
     * @param {String} imgType 画像拡張子
     */
    async getImg(imgSrc, imgType) {
      try {
        // 問題の画像取得
        this.image = await questionRepository.getQuestionImage(imgSrc)
        const suffix = this.questionList.tab.ext
        // 正規表現を動的に作成
        const regex = new RegExp(`\\.${imgType}`);

        // タブ画像のパスを作成
        suffix.forEach(async (suffix, index) => {
          const convertedImgSrc = imgSrc.replace(regex, `_${suffix}.${imgType}`);
          // タブごとの画像を取得する
          this.settingList[index].content =
            await questionRepository.getQuestionImage(convertedImgSrc)
        })
      } catch (error) {
        console.error(error)
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.show-three-point {
  max-width: fit-content;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
}
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: table;
  transition: opacity 0.3s ease;

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;

    .modal-container-outer {
      width: 100%;
      margin-left: auto;
      margin-right: auto;

      .modal-default-button {
        position: absolute;
        left: calc(100vw - 50px);
      }

      .modal-container {
        position: relative;
        width: calc(100vw - 100px);
        height: calc(100vh - 20px);
        margin: auto;
        padding: 15px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
        transition: all 0.3s ease;
        .modal-contents-area {
          display: flex;
          flex-direction: column;
          .modal-contents-area-inner {
            height: 100%;
          }
        }
      }
    }
  }
}

.preview-wrapper {
  min-height: 0;
  flex: 1;
}
</style>
